"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsInviteComponent = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var input_1 = require("../../components/input/input");
var input_select_1 = require("../../components/input/input.select");
var input_state_1 = require("../../components/input/input.state");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var INVITE_SUCCESS = { key: i18n_1.T.ACCOUNTS_INVITE_SUCCESS };
var INVITE_MAX = 10;
var INVITE_EMAIL_ROWS = 3;
var BASIC_ROLE_OPTIONS = [
    { role: core_api_1.IkeUserRole.USER, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_USER) },
    { role: core_api_1.IkeUserRole.ROOT, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_ADMIN) }
];
var EXTRA_ROLE_OPTIONS = [
    { role: core_api_1.IkeUserRole.VIEWER, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_VIEWER) },
    { role: core_api_1.IkeUserRole.DOWNLOADER, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_DOWNLOADER) },
    { role: core_api_1.IkeUserRole.EDITOR, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_EDITOR) },
    { role: core_api_1.IkeUserRole.DATA_ADMIN, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_DATA_ADMIN) }
];
var AccountsInviteComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsInviteComponent, _super);
    function AccountsInviteComponent(ctrl) {
        var _this = _super.call(this, {
            title: i18n_1.T.ACCOUNTS_INVITE_TITLE,
            confirm: i18n_1.T.ACCOUNTS_INVITE,
            success: INVITE_SUCCESS
        }) || this;
        _this.email = new input_state_1.InputState(i18n_1.T.SIGNUP_EMAIL);
        _this.role = new input_select_1.SelectInputState(i18n_1.T.ACCOUNTS_ROLE);
        _this.ctrl = ctrl;
        _this.addState(_this.email);
        _this.addState(_this.role);
        BASIC_ROLE_OPTIONS.forEach(function (role) { return _this.role.addOption({ key: role.label, value: role.role }); });
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_EXTRA_ROLES) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
            EXTRA_ROLE_OPTIONS.forEach(function (role) { return _this.role.addOption({ key: role.label, value: role.role }); });
        }
        _this.email.isRequired = true;
        _this.email.type = input_state_1.InputStateTypes.TEXT;
        _this.role.isRequired = true;
        return _this;
    }
    Object.defineProperty(AccountsInviteComponent.prototype, "nodes", {
        get: function () {
            return [
                (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.ACCOUNTS_INVITE_CONFIRM)),
                (0, mithril_1.m)('div', { style: 'color:' + theme_1.DefaultTheme.font.color.error }, this.role.isValid ? '' : (0, i18n_1.Translate)(i18n_1.T.ACCOUNTS_INVITE_CHOOSE_USER_ROLE)),
                input_select_1.SelectInputComponent.view(this.role),
                input_1.Input.view(this.email, { rows: INVITE_EMAIL_ROWS })
            ];
        },
        enumerable: false,
        configurable: true
    });
    AccountsInviteComponent.prototype.submit = function () {
        var emails = this.getEmails();
        var role = this.role.value;
        return this.ctrl.inviteUsers(emails, role);
    };
    AccountsInviteComponent.prototype.failToChange = function (e) {
        this.email.setError(i18n_1.T.EMAIL_INVALID);
        var existingEmails = [];
        var invalidEmails = [];
        if (core_shared_1.IkeRequestErrorChecker.isValidationFailed(e)) {
            for (var _i = 0, _a = e.errors; _i < _a.length; _i++) {
                var error = _a[_i];
                if (error.codes === 'already_exists') {
                    existingEmails.push(error.message);
                }
                else if (error.codes === 'invalid') {
                    invalidEmails.push(error.message);
                }
            }
        }
        if (existingEmails.length > 0) {
            notification_service_1.NotificationService.warn({
                key: i18n_1.T.ACCOUNTS_INVITE_EXISTING_USER,
                attrs: existingEmails
            });
        }
        if (invalidEmails.length > 0) {
            notification_service_1.NotificationService.error({
                key: i18n_1.T.ACCOUNTS_INVITE_INVALID_USER,
                attrs: invalidEmails
            });
        }
        this.email.setSelected(true);
    };
    AccountsInviteComponent.prototype.validate = function () {
        var emails = this.getEmails();
        if (!this.email.isFilled || emails.length === 0) {
            this.email.setError(i18n_1.T.EMAIL_INVALID);
        }
        else if (emails.length > INVITE_MAX) {
            this.email.setError((0, i18n_1.Translate)(i18n_1.T.ACCOUNTS_INVITE_MAX, INVITE_MAX));
        }
        else {
            this.email.setError('');
        }
    };
    AccountsInviteComponent.prototype.getEmails = function () {
        if (this.email.value == null) {
            return [];
        }
        var emails = this.email.value.split(/[,\n\r]/);
        var output = [];
        for (var _i = 0, emails_1 = emails; _i < emails_1.length; _i++) {
            var email = emails_1[_i];
            var toAdd = email.toLowerCase().trim();
            if (output.indexOf(toAdd) > -1) {
                continue;
            }
            if (toAdd.indexOf('@') === -1) {
                continue;
            }
            output.push(toAdd);
        }
        return output;
    };
    return AccountsInviteComponent;
}(modal_form_component_1.ModalFormComponent));
exports.AccountsInviteComponent = AccountsInviteComponent;
//# sourceMappingURL=accounts.confirm.invite.js.map